<template>
  <div id="wrapper">
    <div class="aboutUs-1"></div>
    <div class="aboutUs-2"></div>
    <div class="aboutUs-3"></div>
    <div class="aboutUs-4"></div>
    <div class="aboutUs-5"></div>
    <div class="certification">
      <div class="headline">
        <p>米兔十分重视技术研发</p>
        <p>已取得2项高新技术产品发明专利 及 29项软件著作权</p>
      </div>
      <el-carousel
        indicator-position="none"
        :interval="3000"
        :height= "bannerHeight + 'px'"
        type="card"
        arrow="always" >
        <el-carousel-item v-for="(item,index) in towerPhoto" :key=item >
          <el-image
            :src=item
            @load="imgLoad"
            :fit="'contain'"
            :preview-src-list="towerPhoto">
          </el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  import elImageViewer from 'element-ui/packages/image/src/image-viewer'
  export default {
    name: "aboutUs",
    components: { elImageViewer },
    data() {
      return {
        towerPhoto: [
          "../../static/images/certification/certification-1.png",
          "../static/images/certification/certification-2.png",
          "../static/images/certification/certification-3.png",
          "../static/images/certification/certification-4.png",
          "../../static/images/certification/certification-5.png",
          "../../static/images/certification/certification-6.png",
          "../../static/images/certification/certification-7.png",
          "../../static/images/certification/certification-8.png",
          "../../static/images/certification/certification-9.png",
          "../../static/images/certification/certification-10.png",
          "../../static/images/certification/certification-11.jpg",
          "../../static/images/certification/certification-12.jpg",
          "../../static/images/certification/certification-13.jpg",
          "../../static/images/certification/certification-14.jpg",
          "../../static/images/certification/certification-15.jpg",
        ],
        bannerHeight: '',
      }
    },
    methods: {
      imgLoad(){
        this.$nextTick(()=> {
          let height = document.getElementsByClassName("el-image")[0].clientHeight;
          if (height > this.bannerHeight) this.bannerHeight = height;
        });
      }
    },
    mounted() {
      window.addEventListener('resize', () => {
        let height = document.getElementsByClassName("el-image")[0].clientHeight;
        if (height > this.bannerHeight) this.bannerHeight = height;
      }, false);

    }
  }
</script>

<style scoped>
  .aboutUs-1{
    position: relative;
    max-height: 47.06rem;
    padding-top: 39%;
    background: url("../../static/images/home/aboutUs-1.png") no-repeat center / cover;
  }

  .aboutUs-2{
    position: relative;
    max-height: 46.38rem;
    padding-top: 38%;
    background: url("../../static/images/home/aboutUs-2.png") no-repeat center / cover;
  }

  .aboutUs-3{
    position: relative;
    max-height: 55.5rem;
    padding-top: 46%;
    background: url("../../static/images/home/aboutUs-3.png") no-repeat center / cover;
  }

  .aboutUs-4{
    position: relative;
    max-height: 47.75rem;
    padding-top: 40%;
    background: url("../../static/images/home/aboutUs-4.png") no-repeat center / cover;
  }

  .certification{
    padding: 3rem 15%;
  }
  .certification>.headline{
    font-size: 1.5rem;
    font-weight: bold;
    color: #F47423;
    line-height: 1.5rem;
    text-align: center;
    margin-bottom: 4rem;
  }


  @media (max-width: 768px) {
    .aboutUs-1{
      position: relative;
      max-height: 197.93rem;
      padding-top: 436%;
      margin: 5rem auto 2.5rem;
      background: url("../../static/images/home/aboutUsH5-1.png") no-repeat center / cover;
    }

    .aboutUs-2,
    .aboutUs-3,
    .aboutUs-4,
    .certification>.headline{
      display: none;
    }

    .certification{
      padding: 3rem 5%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue